import { render, staticRenderFns } from "./ThePriceFooter.vue?vue&type=template&id=3db6197b&scoped=true"
import script from "./ThePriceFooter.vue?vue&type=script&lang=js"
export * from "./ThePriceFooter.vue?vue&type=script&lang=js"
import style0 from "./ThePriceFooter.vue?vue&type=style&index=0&id=3db6197b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6197b",
  null
  
)

export default component.exports